
import {mergeMap,  flatMap } from 'rxjs/operators';
import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar,MatDialog} from '@angular/material';
import { AppService } from '../commons/app.service';
import {AclService} from '../commons/acl/acl.service';
import { Account, Project } from '4d-mapper';
import { forkJoin, Observable } from 'rxjs';

import { Location } from '@angular/common';
import {BaseComponent} from '../commons/BaseComponent';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';
import { TranslateService } from '@ngx-translate/core';
import { LoadingSpinner } from '../commons/ui/loading-spinner';
import { User } from 'vasat';
import { FdmPlugin } from '../commons/plugins/plugins';

@Component({
    selector: 'signup-comp',
    templateUrl: './oauth.component.html'

})
export class OAuthComponent extends BaseComponent {


    user:User
    
    account:Account 

    error:any = null;

    // permissions
    allowed: any = null;

    isShare:boolean
    constructor(protected service:AppService,private path:ActivatedRoute,private r:Router, public snackBar: MatSnackBar, 
        public dialog: MatDialog, public permissions: AclService, public location:Location, applicationEvents:XsApplicationEventsService,
        private t:TranslateService){
        super(r, snackBar, dialog)
    }
    ngOnInit() {
       
        LoadingSpinner.end();
        
        let pathS = this.path.snapshot;

        // console.log ( 'oauth.com.ts :: init', pathS );

        // has the link got QueryParams 'code' and 'client' coming through?
        if(pathS.queryParams.code && pathS.params.client) {
            // console.log("Code: " + pathS.queryParams.code)
            // console.log("client: " + pathS.params.client)
            let host = window.location.origin + this.location.prepareExternalUrl("")
            // console.log("ENTER host: " + host)
            this.service.V.config.clientId = '4dmapper'

            this.service.V.verifyOAuthUrl(pathS.params.client,pathS.queryParams.code,  host + this.routes.AUTH_OAUTH +"/" + pathS.params.client).pipe(
                mergeMap(_ => this.service.refreshMe()))
                .subscribe(s => {
                    var sess = this.service.V.localSession()
                    this.user = sess.user
                    if(sess.user && sess.user['isNewSocialMedia']){
                        this.service.V.searchByObject(Account).queryObservable().subscribe(a => {
                            this.account = a.items.find(a => a.uid != 'sample')
                            if(this.account.name.startsWith('Unknown '))
                                this.account.name = ''
                        })
                        this.loading = false
                    }
                    else if(pathS.queryParams.state){
                        let s = pathS.queryParams.state.split(',')
                        s[0] = '/' + s[0]

                        //console.log(s)
                        this.r.navigate(s,{replaceUrl:true})
                    }
                    

                    else{
                        this.r.navigateByUrl('/app')
                    }
                    //
                },
                e => {
                    this.error = e
                    this.loading = false;
                    LoadingSpinner.end();
                })

            this.loading = true
        }

        // no? What about just params 'token' and 'secret'?
        else if ( pathS.params.token && pathS.params.secret ) {

            this.isShare = true;
            this.loading = true;

            this.service.V.config.clientId = pathS.params.token;
            this.service.V.config.clientSecret = pathS.params.secret;

            var obs:Observable<any> = this.service.V.token ?
                this.service.logout().pipe(mergeMap(s => this.service.V.loginWithClientCredentialsObservable()))
                :
                this.service.V.loginWithClientCredentialsObservable()

            obs.subscribe( tmp =>
                this.service.V.searchByObject(Project).queryObservable().subscribe(res => {

                    // console.log ( 'shared link (token:'+pathS.params.token+')', tmp, res );

                    // results mean there's a project
                    if(res.items.length){

                        localStorage['last4d_token'] = pathS.params.token
                        localStorage['last4d_secret'] = pathS.params.secret

                        // shortcut for Project
                        let p = res.items[0];

                        // find the client object with the sharable metadata
                        p.shareClients.queryObservable().subscribe( find_client => {

                            // should we do the route?
                            let onwards = true;

                            // is there a Client object? (It's got all the shared metadata in it)
                            if ( find_client.items.length ) {

                                // shortcut
                                let c = find_client.items[0];

                                // scene reference
                                let scene = null;

                                // camera reference
                                let camera = null;

                                // if there's a scene reference, pass it in as a parameter to the Route
                                if ( c['activeSceneId'] ) {
                                    scene = c['activeSceneId'];
                                }

                                // if there's a camera reference, pass it in as a parameter to the Route
                                if ( c['camera'] ) {
                                    camera = c['camera'];
                                }

                                if ( c['expiration'] ) {

                                    let days = c['expiration'];

                                    // milliseconds in a day
                                    let msd = (24*60*60*1000);
                                    
                                    // calculate date offset
                                    let daysMs = msd * days;

                                    // today!
                                    let today = new Date().getTime();

                                    // when created
                                    let creation = new Date( c['dateMade'] ).getTime();

                                    let ageMs = ( today - creation ) / msd;

                                    // http://localhost:4200/auth/share/s_8_alex_thinkplot_org/M5QQS5HNUTUISKPICGMJHT32MXCBVYVVII5MYIQYMLFRAHMLRV

                                    // Link expired 

                                    if ( ageMs > daysMs ) {
                                        this.loading = false
                                        this.t.get('SIGNIN.LINK_EXPIRY').subscribe(s => 
                                            this.error = {message:s}
                                        )
                                        LoadingSpinner.end();
                                        onwards = false;
                                    }
                                }

                                // SJ - Alex Ive truned this off as the server now gives the permissions
                                /*
                                if ( c['permissions'] ) {

                                    // convert permission objects to mapped objects
                                    var result = c['permissions'].reduce? c['permissions'].reduce(function(map, obj) {
                                        map[obj.key] = obj;
                                        return map;
                                    }, {} ):c['permissions'] ;

                                    // our extra permission rules template
                                    let extra = {
                                        id: 'view_link', 
                                        cannot: [ '@annotations:*', 'scene:switch', 'layer:toggle,download', 'photogrammetry:*' ],
                                        can: [],
                                    };
                                    // inspections allowed
                                    if ( result['inspect']['value'] ) {
                                        extra.can.push('annotations:see');
                                        extra.can.push('annotations:create_report');
                                        extra.can.push('pin:*');
                                    }
                                    // measurements allowed
                                    if ( result['measure']['value'] ) {
                                        extra.can.push('annotations:see');
                                        extra.can.push('line:*');
                                        extra.can.push('area:*');
                                        extra.can.push('volume:*');
                                        extra.can.push('points:*');
                                    }
                                     // download
                                    if ( result['download']['value'] ) {
                                        extra.can.push('layer:download');
                                    }
                                    // see all scenes
                                    if ( result['see_all_scenes']['value'] ) {
                                        extra.can.push('scene:switch');
                                    }
                                    // see disabled layers
                                    if ( result['see_disabled_layers']['value'] ) {
                                        extra.can.push('layer:toggle');
                                    }

                                    // add the extra permissions
                                    this.permissions.addCollection ( 'extra', [], [ extra ] );

                                    // force refresh with extra rules
                                    this.allowed = this.permissions.getAccess('view_link', true);

                                    // console.log ( 'shared link', result, c['permissions'], extra, this.allowed );
                                }*/

                                // shall we move ahead?
                                if ( onwards ) {
                                    // Japan request: Workaround to enable basemap plugin for shared links.
                                    // Only care about basemap plugin so far (under generic category) but we enable these other ones just in case the plugin category gets changed
                                    this.pluginManager.pluginCategories.push(FdmPlugin.category.beta)
                                    this.pluginManager.pluginCategories.push(FdmPlugin.category.advanced)
                                    this.pluginManager.pluginCategories.push(FdmPlugin.category.generic)

                                    //console.log ( 'shared link : forward route /map/' + p.id, scene, camera, atob( btoa(JSON.stringify(camera))), c );
                                    this.router.navigate(['/map',p.id] , { queryParams: { activeSceneId: scene, camera: btoa(JSON.stringify(camera)) } })
                                }
                            }

                        });

                    
                    }

                    // No projects shared
                    else{
                        this.loading = false;
                        LoadingSpinner.end();
                        this.t.get('SIGNIN.NO_PROJECT').subscribe(s => 
                        this.error = {message:s}
                        )
                    }
                },e => {
                    this.error = e
                    this.loading = false;
                    LoadingSpinner.end();
                })
            ,e => {
                    this.error = e
                    this.loading = false;
                    LoadingSpinner.end();
                })

        // No? Error, then invalid access
        } else {
            this.t.get('SIGNIN.INV_ACCESS').subscribe(s => 
                this.error = {message:s}
            )
            LoadingSpinner.end();
        }

    }
    activate(){
        delete this.user['isNewSocialMedia']
        this.loading = true
        forkJoin([this.user.saveObservable(),this.account.saveObservable()]).subscribe(_ => 
            this.r.navigateByUrl('/app')
        ,
            e => {
                this.error = e
                this.loading = false
            }
        )
    }
}
